import React from 'react';

import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';

export const Container = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.container, style]} />
);

export const Heading = withTypography({
  accessible: true,
  variant: 'headerOne',
  m: '$0',
  p: '$0',
});

export const Content = withTypography({
  accessible: true,
  variant: 'copyOne',
  textAlign: 'center',
  my: '$4',
});

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
});
